export default __webpack_public_path__ + "static/media/timer-frame.edeeeccc.png";